// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateReasonForLeavingMutationVariables = Types.Exact<{
  input: Types.CreateReasonForLeavingInput;
}>;

export type CreateReasonForLeavingMutation = { __typename?: 'Mutation' } & {
  createReasonForLeaving: { __typename?: 'ReasonForLeavingOutput' } & Pick<Types.ReasonForLeavingOutput, 'id'>;
};

export const CreateReasonForLeavingDocument = /*#__PURE__*/ gql`
    mutation createReasonForLeaving($input: CreateReasonForLeavingInput!) {
  createReasonForLeaving(input: $input) {
    id
  }
}
    `;
export type CreateReasonForLeavingMutationFn = Apollo.MutationFunction<
  CreateReasonForLeavingMutation,
  CreateReasonForLeavingMutationVariables
>;

/**
 * __useCreateReasonForLeavingMutation__
 *
 * To run a mutation, you first call `useCreateReasonForLeavingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReasonForLeavingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReasonForLeavingMutation, { data, loading, error }] = useCreateReasonForLeavingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReasonForLeavingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateReasonForLeavingMutation, CreateReasonForLeavingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReasonForLeavingMutation, CreateReasonForLeavingMutationVariables>(
    CreateReasonForLeavingDocument,
    options,
  );
}
export type CreateReasonForLeavingMutationHookResult = ReturnType<typeof useCreateReasonForLeavingMutation>;
export type CreateReasonForLeavingMutationOptions = Apollo.BaseMutationOptions<
  CreateReasonForLeavingMutation,
  CreateReasonForLeavingMutationVariables
>;
